import {
    getCalendarAssessors,
    getCalendarPitchPresentationAdmins,
    getCalendarWorkshopAdmins,
    getChallenge,
    getChallengesFetchError,
    getChallengesIsFetching,
} from '@selectors/challenges';
import { batch, useDispatch, useSelector } from 'react-redux';
import { RootState } from '@reducers/index';
import { useEffect } from 'react';
import { fetchChallengeCalendarAdminOptions, fetchSingleChallenge } from '@actions/challenges';
import { fetchAllAdminUsers } from '@actions/adminUsers';
import { getAdminUsers } from '@selectors/adminUsers';
import usePrevious from 'lib/src/hooks/usePrevious';

const useFetchSingleChallenge = (id: number) => {
    const dispatch = useDispatch();

    useEffect(() => {
        if (id != null)
            batch(() => {
                dispatch(fetchSingleChallenge(id));
                dispatch(fetchAllAdminUsers());
            });
    }, [dispatch, id]);

    const challenge = useSelector((state: RootState) => getChallenge(state, id));
    const isFetching = useSelector(getChallengesIsFetching);
    const fetchError = useSelector(getChallengesFetchError);
    const adminUsers = useSelector(getAdminUsers);
    const workshopAdmins = useSelector(getCalendarWorkshopAdmins);
    const assessors = useSelector(getCalendarAssessors);
    const pitchPresentationAdmins = useSelector(getCalendarPitchPresentationAdmins);
    const prevSite = usePrevious(challenge.site);

    useEffect(() => {
        const challengeSiteUpdated = !!challenge.site && challenge.site !== prevSite;
        const isNoWorkshopAdmins = Object.keys(workshopAdmins).length === 0;

        if ((challengeSiteUpdated || isNoWorkshopAdmins) && challenge.challengeGroupID) {
            dispatch(fetchChallengeCalendarAdminOptions(challenge.challengeGroupID));
        }
    }, [challenge.site, prevSite, dispatch, challenge.challengeGroupID, workshopAdmins]);

    return {
        challenge,
        isFetching,
        fetchError,
        adminUsers,
        workshopAdmins,
        assessors,
        pitchPresentationAdmins,
    };
};

export default useFetchSingleChallenge;
